import { render } from "./learningCenterGuideTabWrapper.vue?vue&type=template&id=4c7af3ef"
import script from "./learningCenterGuideTabWrapper.vue?vue&type=script&lang=js"
export * from "./learningCenterGuideTabWrapper.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./learningCenterGuideTabWrapper.vue?vue&type=style&index=0&id=4c7af3ef&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__